import React from 'react';

import { Inline } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import { BodyText } from '../../../../../ui';
import { TimeTimeIcon } from '../../../../../ui/Icons';

type TimeToCompleteProps = {
  time: string;
  testId: string;
};

const TimeToComplete: React.FC<TimeToCompleteProps> = ({ time, testId }) => (
  <Inline
    color={colors.chill}
    paddingX={8}
    paddingY={4}
    borderRadius={8}
    alignItems="center"
    space={4}
  >
    <TimeTimeIcon color={colors.slate} width={11} height={11} />
    <BodyText testID={testId} appearance="small" color={colors.metal}>{time}</BodyText>
  </Inline>
);

export default TimeToComplete;
